import { childTypes } from '@/enums/childTypes';

export class groupingRelationshipItem
{
	itemID: number;
	parentID: number | null;
	childID: number | null;
	childType: childTypes | null;
	orderIndex: number | null;
	itemName: string;
}